import {
  Text, Box, Tooltip, Badge,
} from '@usealloy/component-library';
import { useAppSelector } from '~/store/reduxHooks';
import { selectTagsByName } from 'flow/store/redux/selectors';
import TagSquare from '~/components/TagSquare';
import type { CellContext } from '@tanstack/table-core';
import { RiskRatingDisplay } from '~/components/RiskRatingDisplay';
import { StyledColoredDot } from './styles';
import type { RiskFactor } from '../types';

export const RiskFactorCell = ({ getValue, row }: CellContext<RiskFactor, string>) => {
  const name = getValue();
  const { actionType } = row.original;
  const tagsByName = useAppSelector(selectTagsByName);
  const tag = actionType === 'tag' ? tagsByName[name] : null;

  if (tag) {
    return (
      <Box gap={1} alignItems="center" justifyContent="flex-start">
        <TagSquare id={`tag-square-${name}`} color={tag?.tag_color} tooltipText={tag?.description || name} />
        <Text>{name}</Text>
      </Box>
    );
  }

  return <Text>{name}</Text>;
};

export const InputCell = ({ row }: CellContext<RiskFactor, string>) => {
  const { actionType, input } = row.original;
  const isTag = actionType === 'tag';
  const isTagSet = isTag && input === 'Set';

  if (!isTag) {
    return <Text>{input == null ? 'null' : String(input)}</Text>;
  }

  return (
    <Box alignItems="center" justifyContent="flex-start">
      <StyledColoredDot isVisible={isTagSet} />
      <Tooltip
        content={isTagSet ? 'Satisfies logic' : 'Does not satisfy logic'}
        side="top"
      >
        <Badge
          backgroundColor={isTagSet ? 'var(--cl-yellow-100)' : 'var(--cl-gray-100)'}
        >
          {input}
        </Badge>
      </Tooltip>
    </Box>
  );
};

export const RiskRatingCell = ({ row }: CellContext<RiskFactor, string>) => (
  <RiskRatingDisplay
    color={row.original?.color}
    riskOutput={row?.original?.riskOutput}
    riskLevel={row?.original?.riskLevel}
  />
);

